/* @ngInject */
const idToString = (

) => {
  return (item) => {
    if (item === undefined || item === null) {
      return null
    }
    if (!item.toString().match(new RegExp('^[0-9]{12}$'))) {
      return item
    }

    let res = ''
    const id = item.toString()
    res += id.slice(0, 2)
    res += ' ' + id.slice(2, 4)
    res += ' ' + id.slice(4, 7)
    res += ' ' + id.slice(7, 11)
    res += ' - ' + id.slice(11, 12)

    return res
  }
}

export default idToString



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/filters/entities/wagon/idToString.filter.js